import React, { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { useLocation, Outlet } from 'react-router-dom'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import _ from 'lodash'

import track from '../index'
import { setCrispData, crispHide } from '../crisp'

const GET_ME = gql`
  query getMe {
    me {
      _id
      email
      name
      createdAt
      profile {
        fullName
        phone
        phoneVerified
        countryCode
      }
      verified
    }
  }
`

const Provider = () => {
  const { data } = useQuery(GET_ME)
  const me = data && data.me
  const location = useLocation()
  const [isOn, setIsOn] = useState(false)
  const [lastPath, setLastPath] = useState(location.pathname)

  useEffect(() => {
    if (lastPath !== location.pathname) {
      setLastPath(location.pathname)
      track({ action: 'page_view', userId: _.get(me, '_id', null), path: location.pathname })
    }
  }, [location, me, lastPath])

  useEffect(() => {
    const stop = () => {
      setIsOn(false)
    }

    const start = () => {
      if (me) {
        setCrispData(me)
      }
      setIsOn(true)
    }

    if (location.pathname.startsWith('/exchange')) {
      if (isOn) {
        stop()
      }
      crispHide()
      return
    }

    if (!isOn) {
      start()
    }
  }, [location.pathname, isOn, me])

  return <Outlet />
}

Provider.propTypes = {
  children: PropTypes.node,
}

export default Provider
